<template>
  <div v-if="showAd">
    <div :id="index ? type + index : type"
         :class="[type, description]" />
    <div v-if="typeAux"
         :id="typeAux" />
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: String,
      default: ''
    },
    slotName: {
      type: String,
      default: 'default'
    },
    type: {
      type: String,
      default: ''
    },
    typeAux: {
      type: String,
      default: undefined
    },
    networkId: {
      type: String,
      default: '5555,21692105105'
    },
    advertiser: {
      type: String,
      default: 'WEGOW.ES'
    },
    values: {
      type: Object,
      default: () => {}
    },
    description: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: undefined
    }
  },
  data: () => ({
    showAd: true,
    mappingWegowSelected: undefined,
    sizes: {
      'bannerfixed-sc-top': [
        [970, 250],
        [728, 90],
        [200, 200]
      ],
      'banner-sc-top': [
        [970, 90],
        [728, 90]
      ],
      'sc-mpu-top': [
        [300, 250],
        [300, 250]
      ],
      'sc-superbanner-btf': [
        [970, 250],
        [728, 90]
      ],
      'sc-mpu-btf': [
        [300, 250],
        [300, 600]
      ],
      'sc-dynamic-ad': [
        [320, 100],
        [320, 50],
        [1, 1]
      ]
    }
  }),
  mounted() {
    var self = this
    function createSlot() {
      window.googletag.cmd.push(function() {
        var mappingWegowgeo = window.googletag
          .sizeMapping()
          .addSize(
            [320, 200],
            [
              [320, 50],
              [320, 100]
            ]
          )
          .addSize([729, 200], [728, 90])
          .addSize(
            [980, 200],
            [
              [728, 90],
              [970, 250]
            ]
          )
          .addSize(
            [1025, 200],
            [
              [728, 90],
              [970, 250]
            ]
          )
          .build()

        var mappingWegowgeompuleft = window.googletag
          .sizeMapping()
          .addSize(
            [320, 200],
            [
              [300, 600],
              [300, 250],
              [125, 125]
            ]
          )
          .addSize(
            [729, 200],
            [
              [300, 600],
              [300, 250],
              [125, 125]
            ]
          )
          .addSize(
            [980, 200],
            [
              [300, 600],
              [300, 250],
              [125, 125]
            ]
          )
          .addSize(
            [1025, 200],
            [
              [300, 600],
              [300, 250],
              [125, 125]
            ]
          )
          .build()

        var mappingWegowmpucasf = window.googletag
          .sizeMapping()
          .addSize(
            [320, 200],
            [
              [300, 600],
              [300, 250]
            ]
          )
          .addSize([729, 200], [])
          .addSize([980, 200], [])
          .addSize([1025, 200], [])
          .build()

        var mappingWegowmpubtfcasf = window.googletag
          .sizeMapping()
          .addSize(
            [320, 200],
            [
              [300, 600],
              [300, 250]
            ]
          )
          .addSize([729, 200], [])
          .addSize([980, 200], [])
          .addSize([1025, 200], [])
          .build()

        var mappingWegowsuperbannerbtfcasf = window.googletag
          .sizeMapping()
          .addSize([320, 200], [])
          .addSize([729, 200], [728, 90])
          .addSize(
            [980, 200],
            [
              [728, 90],
              [970, 250]
            ]
          )
          .addSize(
            [1025, 200],
            [
              [728, 90],
              [970, 250]
            ]
          )
          .build()

        if (self.values.country === '53' ||
            self.$route.params.region === 'ch') {
          self.advertiser = 'WEGOW.CL'
        } else if (self.values.country === '19' ||
                  self.$route.params.region === 'ar') {
          self.advertiser = 'WEGOW.AR'
        } else if (self.values.country === '156' ||
                  self.$route.params.region === 'mx') {
          self.advertiser = 'WEGOW.MX'
        }

        if (self.type === 'sc-top') {
          self.mappingWegowSelected = mappingWegowgeo
        } else if (
          self.type === 'sc-mpu-top' &&
          self.page === 'contenido'
        ) {
          self.mappingWegowSelected = mappingWegowgeompuleft
        } else if (
          self.type === 'sc-mpu-top'
        ) {
          self.mappingWegowSelected = mappingWegowmpucasf
        } else if (
          self.type === 'sc-superbanner-btf'
        ) {
          self.mappingWegowSelected = mappingWegowsuperbannerbtfcasf
        } else if (
          self.type.indexOf('sc-mpu-btf') !== -1
        ) {
          self.mappingWegowSelected = mappingWegowmpubtfcasf
        }
        try {
          self.slot = window.googletag
          .defineSlot(
            `/${self.networkId}/${self.advertiser}/${self.slotName}`,
            self.sizes[self.type] || self.sizes[`${self.description}-${self.type}`],
            self.index ? self.type + self.index : self.type
          )
          .defineSizeMapping(self.mappingWegowSelected)
          .addService(window.googletag.pubads())
          .setTargeting('tema', window.location.pathname.substr(2))
          .setTargeting(
            'seccion',
            self.page
          )
          .setTargeting('tags', document.title.split(/[:.\/ -]/).join(','))
          .setTargeting('lazy', 'disable')
        } catch (error) {
          console.log(error)
          console.log(
            `/${self.networkId}/${self.advertiser}/${self.slotName}`,
            self.sizes[self.type] || self.sizes[`${self.description}-${self.type}`],
            self.type)
        }
        if (self.typeAux) {
          window.googletag
            .defineOutOfPageSlot(
              `/${self.networkId}/${self.advertiser}/${self.slotName}`,
              self.typeAux
            )
            .addService(window.googletag.pubads())
            .setTargeting('tema', window.location.pathname.substr(2))
            .setTargeting('seccion', self.slotName.replace('BTF'))
            .setTargeting('tags', document.title.split(/[:.\/ -]/).join(','))
            .setTargeting('lazy', 'disable')
        }
        window.googletag.pubads().addEventListener('slotRenderEnded', event => {
          if (self.slot === event.slot) {
            if (event.isEmpty) {
              console.log(`empty ${self.type} id: `, `${self.type}`)
              console.log(`empty ${self.type}: `, event.slot)
            }
          }
        })

        if (self.slot && typeof self.slot.addService === 'function') {
          self.slot[self.type] = true
          self.slot.addService(window.googletag.pubads())
          window.googletag.display(self.type)
          if (self.typeAux) window.googletag.display(self.typeAux)
          window.googletag.pubads().refresh([self.slot])
        }
      })
    }
    if (typeof window.canRunAds !== 'undefined' && window.canRunAds) {
      createSlot()
    } else {
      this.showAd = false
    }
  }
}
</script>

<style lang="scss">
#wegow-default-styles{
  .sc-top{
    max-width: max-content;
    min-width: 300px;
    margin: 15px auto;
    &.bannerfixed{
      position: fixed;
      bottom: 0;
    }
  }
  .sc-mpu-top{
    max-width: max-conten;
    min-width: 300px;
    margin: auto;
    margin-bottom: 25px;
  }
  .sc-superbanner-btf{
    max-width: max-content;
    min-width: 300px;
    margin: auto;
    margin-bottom: 25px;
  }
  .sc-mpu-btf{
    max-width: max-content;
    min-width: 300px;
    margin: auto;
    margin-bottom: 25px;
  }
}
</style>
